(function() {
  // Find all instances of this section on the page (theme editor may render multiple)
  var sections = document.querySelectorAll('[data-sbr-book-product]');
  sections.forEach(function(root) {
    var sectionId = root.getAttribute('data-sbr-book-product');
    if (!sectionId) return;
    initSbrBookProduct(root, sectionId);
  });

  function initSbrBookProduct(root, sectionId) {

    var selectedVariantId = null;

    // ── RESOLVE PRICES + AVAILABILITY VIA SHOPIFY AJAX API ──
    var priceTargets    = root.querySelectorAll('[data-sbr-price-target]');
    var variantIds      = Array.from(priceTargets).map(function(el) {
      return el.getAttribute('data-sbr-price-target');
    }).filter(Boolean);

    var variantAvailability = {};
    var atcBtn = root.querySelector('[data-sbr-atc]');

    if (variantIds.length > 0) {
      variantIds.forEach(function(vid) {
        fetch('/variants/' + vid + '.js')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var targets = root.querySelectorAll('[data-sbr-price-target="' + vid + '"]');
            targets.forEach(function(el) {
              if (data && data.price) {
                var formatted = '$' + (data.price / 100).toFixed(2);
                el.textContent = formatted;
              }
            });

            var isAvailable = data && data.available === true;
            variantAvailability[vid] = isAvailable;

            var btn = root.querySelector('[data-sbr-variant-id="' + vid + '"]');
            if (btn && !isAvailable) {
              btn.classList.add('sbr-format-btn--out-of-stock');
              btn.setAttribute('data-sbr-out-of-stock', 'true');
              var priceEl = btn.querySelector('.sbr-format-price');
              if (priceEl) priceEl.textContent = 'Out of Stock';
            }

            if (selectedVariantId === vid && atcBtn) {
              if (!isAvailable) {
                atcBtn.disabled    = true;
                atcBtn.textContent = 'Out of Stock';
              }
            }
          })
          .catch(function() {});
      });
    }

    // ── FORMAT BUTTON SELECTION ──
    var formatBtns = root.querySelectorAll('.sbr-format-btn');

    function selectFormat(btn) {
      formatBtns.forEach(function(b) { b.classList.remove('sbr-format-btn--active'); });
      btn.classList.add('sbr-format-btn--active');
      selectedVariantId = btn.getAttribute('data-sbr-variant-id');

      if (atcBtn) {
        var outOfStock = btn.getAttribute('data-sbr-out-of-stock') === 'true'
                      || variantAvailability[selectedVariantId] === false;
        if (outOfStock) {
          atcBtn.disabled    = true;
          atcBtn.textContent = 'Out of Stock';
        } else {
          atcBtn.disabled    = false;
          atcBtn.textContent = 'Add to Cart';
        }
      }
    }

    formatBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { selectFormat(btn); });
    });

    if (formatBtns.length > 0) {
      selectFormat(formatBtns[0]);
    }

    // ── ADD TO CART — CART SWAP APPROACH ──
    if (atcBtn) {
      atcBtn.addEventListener('click', function() {
        if (!selectedVariantId) return;

        atcBtn.disabled    = true;
        atcBtn.textContent = 'Adding...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(selectedVariantId, 10),
            quantity: 1
          })
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.id) {
            atcBtn.textContent = 'Added!';
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { variantId: selectedVariantId } }));
            setTimeout(function() {
              atcBtn.disabled    = false;
              atcBtn.textContent = 'Add to Cart';
            }, 2000);
          } else {
            atcBtn.disabled    = false;
            atcBtn.textContent = 'Try Again';
          }
        })
        .catch(function() {
          atcBtn.disabled    = false;
          atcBtn.textContent = 'Try Again';
        });
      });
    }

    // ── READ MORE TOGGLE ──
    var readMoreBtn = document.getElementById('sbr-read-more-' + sectionId);
    var descEl      = document.getElementById('sbr-desc-' + sectionId);

    if (readMoreBtn && descEl) {
      readMoreBtn.addEventListener('click', function() {
        var expanded = descEl.classList.toggle('sbr-desc--expanded');
        readMoreBtn.classList.toggle('sbr-read-more--open', expanded);
        readMoreBtn.setAttribute('aria-expanded', expanded.toString());
        var labelSpan = readMoreBtn.querySelector('.sbr-read-more-label');
        if (labelSpan) labelSpan.textContent = expanded ? 'read less' : 'read more';
      });
    }

    // ── SCORE LINK SCROLL ──
    var scoreLink = root.querySelector('[data-sbr-score-link]');
    if (scoreLink) {
      scoreLink.addEventListener('click', function() {
        var statsSection = document.querySelector('.sbr-book-stats-section');
        if (statsSection) {
          statsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // ── DRM POPUP ──
    var drmTrigger = root.querySelector('[data-sbr-drm-trigger]');
    var drmPopup   = document.getElementById('sbr-drm-popup-' + sectionId);
    var drmOverlay = document.getElementById('sbr-drm-overlay-' + sectionId);
    var drmClose   = drmPopup ? drmPopup.querySelector('[data-sbr-drm-close]') : null;

    function openDrmPopup() {
      if (!drmPopup || !drmOverlay) return;
      drmPopup.classList.add('sbr-drm-popup--open');
      drmOverlay.classList.add('sbr-drm-overlay--open');
      document.body.style.overflow = 'hidden';
      if (drmClose) drmClose.focus();
    }

    function closeDrmPopup() {
      if (!drmPopup || !drmOverlay) return;
      drmPopup.classList.remove('sbr-drm-popup--open');
      drmOverlay.classList.remove('sbr-drm-overlay--open');
      document.body.style.overflow = '';
      if (drmTrigger) drmTrigger.focus();
    }

    if (drmTrigger) {
      drmTrigger.addEventListener('click', function(e) {
        e.stopPropagation();
        openDrmPopup();
      });
    }

    if (drmClose) {
      drmClose.addEventListener('click', closeDrmPopup);
    }

    if (drmOverlay) {
      drmOverlay.addEventListener('click', closeDrmPopup);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drmPopup && drmPopup.classList.contains('sbr-drm-popup--open')) {
        closeDrmPopup();
      }
    });

  }
})();
